import { create } from "zustand";
import type { MenuOption } from "@dealer-center/core-components";
import type { OnSearchInterface } from "./top-bar/search/SearchBar";
import type {
  NavigationMenuItemInterface,
  UserMenuItemsInterface
} from "@dealer-center/ddc-api-commoncontainer-interface";
export const useNavBarStore = create<GetStoreState>(set => {
  return {
    linksMenu: [],
    user: {
      serviceAccount: {}
    },
    nav: [],
    hasBridgeBar: true,
    setVisibility(state) {
      set(newState => {
        return {
          visibility: {
            ...newState.visibility,
            ...state
          }
        };
      });
    },
    visibility: {
      pinLinksMenu: false,
      shouldShowMobileMenu: false,
      shouldSearchBeAnIcon: false,
      shouldShowDealerCenterText: false,
      shouldAccountSelectorBeAnIcon: false,
      shouldShowAccountSelectorInCenter: false,
      showFooter: true,
      shouldNavigationBeAnIcon: false
    },
    setInitalState: (state: SetStoreState) =>
      set({
        linksMenu: state.linksMenu,
        user: state.user,
        nav: state.nav || [],
        hasBridgeBar:
          state.hasBridgeBar === undefined ? true : state.hasBridgeBar,
        availableAccounts: state.availableAccounts,
        selectedAccountName: state.selectedAccountName,
        selectedAccountStatus: state.selectedAccountStatus,
        onSearch: state.onSearch,
        setSelectedAccountId: (accountId: string) => {
          const accountName = state.availableAccounts?.find(
            account => account.value === accountId
          )?.label;
          if (state.setSelectedAccountId) {
            state.setSelectedAccountId(accountId);
          }
          set({ selectedAccountName: accountName });
        }
      }),
    availableAccounts: [],
    selectedAccountName: "",
    selectedAccountStatus: "",
    setSelectedAccountId: (account: string) => {
      set({ selectedAccountName: account });
    }
  };
});

interface GetStoreState extends SetStoreState {
  setInitalState: (state: SetStoreState) => void;
  setVisibility: (state: Partial<VisibilityState>) => void;
  visibility: VisibilityState;
  hasBridgeBar: boolean;
  nav: NavigationMenuItemInterface[];
}

export interface VisibilityState {
  pinLinksMenu: boolean;
  shouldShowAccountSelectorInCenter: boolean;
  shouldShowMobileMenu: boolean;
  shouldSearchBeAnIcon: boolean;
  shouldShowDealerCenterText: boolean;
  shouldAccountSelectorBeAnIcon: boolean;
  showFooter: boolean;
  shouldNavigationBeAnIcon: boolean;
}

interface SetStoreState {
  onSearch?: (value: OnSearchInterface) => void;
  linksMenu?: NavigationMenuItemInterface[];
  user?: UserMenuItemsInterface;
  nav?: NavigationMenuItemInterface[];
  hasBridgeBar?: boolean;
  availableAccounts?: MenuOption[];
  selectedAccountName?: string;
  selectedAccountStatus?: string;
  setSelectedAccountId?: (account: string) => void;
}
